import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleInventoryDataBean,
  FabricStyleSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  SkuBatchInventorySummaryDetailsPrintRequest,
  SKUInventoryBinSummaryRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class InventoryBinSummary extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Inventory-Bin Summary Inquiry",
      isShowExecuteButton: true,
      isShowExitButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      criteria: new SKUBatchInventorySearchCriteria(),
      inventoryDataBean: new FabricStyleInventoryDataBean(),
      fabricStyleData: new FabricStyleBean(),
      pageList: new RestPageListBean(),
      inquiryDataList: [],
      colorList: [],
      isInquiryDatasFound: false,
      onHandQtyDataList: [],
      onHandQtySummaryDataList: [],
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowOnHandQtyPopup: false,
      isShowOnHandQtySummaryPopup: false,
      isDisableFields: false,
      isShowLookUp: true,
      moduleForPopup: [],
      isShowAlertLvl1: false,
      isShowAlertLvl2: false,
      is3PL: false,
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.fetchQuantityAvailableLinesOnly = true;
    criteria.excludeNonWarehouseInventory = true;
    criteria.excludeReserveWarehouseInventory = true;
    this.loadBinInventoryInquiryList(criteria);
  };
  loadBinInventoryInquiryList = (listRequest) => {
    if (
      SecurityAccessManager.SkuBatchInventoryBinSummaryInquiry_IsAccessible()
    ) {
      InventoryService.getSKUBatchInventoriesBinSummary(
        listRequest,
        this.loadBinInventoryInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  loadBinInventoryInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.skuBatchSummaryResult != null) {
      let resultList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchSummaryResult.inventoryBinSummaryDatas
        )
      ) {
        resultList =
          response.data.skuBatchSummaryResult.inventoryBinSummaryDatas;
        this.setState({
          isShowExcelButton: true,
          isShowPDFButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowColorLookup: false,
        isShowLookUp: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  generatePDF = () => {
    this.generateBinInventoryReport(1);
  };
  generateExcel = () => {
    this.generateBinInventoryReport(2);
  };
  generateBinInventoryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ... ",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new SKUInventoryBinSummaryRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SkuBatchInventoryBinSummaryInquiryPDFReport_IsAccessible()
      ) {
        ReportService.getSKUInventoryBinSummaryReport(
          listRequest,
          this.generateBinInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.SkuBatchInventoryBinSummaryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.getSKUInventoryBinSummaryReport(
          listRequest,
          this.generateBinInventoryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateBinInventoryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowAlertLvl1: isShowPopup,
    });
  };
  closeAlertSummaryModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtySummaryPopup: isShowPopup,
      isShowAlertLvl2: isShowPopup,
    });
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl2: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmptyString(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = " ";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        isShowColorLookup: false,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readAndSetFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            isDisable: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readAndSetFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readAndSetFabricStyleResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  clearCriteria = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      disabledTextBox: false,
      isShowColorLookup: false,
      isShowLookUp: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowLookUp: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readAndSetFabricStyle(fabricStyleCode);

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmptyString(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.loadFabricColourBySearchString(e.target.value);
    }
  };

  loadFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let colorCode = e.target.value;
    this.fabricStyleColorSelected(colorCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onHandQuantityClick = (e, val, rowData) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading ...",
      });

      let inventoryDataBean = this.state.inventoryDataBean;
      inventoryDataBean.companyCode = this.companyCode;
      inventoryDataBean.fabricStyleCode = rowData.fabricStyleCode;
      inventoryDataBean.fabricStyleName = rowData.fabricStyleName;
      inventoryDataBean.fabricStyleColorCode = rowData.fabricStyleColorCode;
      inventoryDataBean.skuNumber = rowData.skuNumber;
      inventoryDataBean.uomCode = rowData.uomCode;
      inventoryDataBean.totalOnHandQuantity = rowData.totalOnHandQuantity;

      this.setState({ inventoryDataBean: inventoryDataBean });
      let qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = rowData.fabricStyleCode;
      qtyCriteria.colorCode = rowData.fabricStyleColorCode;
      qtyCriteria.excludeNonWarehouseInventory = true;
      qtyCriteria.fetchQuantityAvailableLinesOnly = true;
      qtyCriteria.excludedLocationCodes =
        this.state.criteria.excludedLocationCodes;
      let exludeReserveInventory =
        ConfigManager.excludeReserveInventoryInATSFlag();
      qtyCriteria.excludeReserveWarehouseInventory = exludeReserveInventory;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      this.loadOnHandQtyListPage(listRequest);
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    InventoryService.getSkuBatchInventoryPageList(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack
    );
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let onHandQtyList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        onHandQtyList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
      this.setState({
        onHandQtyDataList: onHandQtyList,
        isShowOnHandQtyPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtyPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(1);
  };
  generateOnHandQtyExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtyReport(2);
  };
  generateOnHandQtyReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludeNonWarehouseInventory = true;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let exludeReserveInventory =
      ConfigManager.excludeReserveInventoryInATSFlag();
    criteria.excludeReserveWarehouseInventory = exludeReserveInventory;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.reportBean = reportBean;
    ReportService.downloadPopUpItemOnOrderPrintReport(
      listRequest,
      this.generateOnHandQtyResponse,
      this.errorCallBack
    );
  };
  generateOnHandQtyResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  onHandQtySummaryOnClick = (e) => {
    if (e.detail === 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading ...",
      });
      let inventoryDataBean = this.state.inventoryDataBean;
      let criteria = new SKUBatchInventorySearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
      criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
      criteria.excludeNonWarehouseInventory = true;
      criteria.fetchQuantityAvailableLinesOnly = true;
      let exludeReserveInventory =
        ConfigManager.excludeReserveInventoryInATSFlag();
      criteria.excludeReserveWarehouseInventory = exludeReserveInventory;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      InventoryService.getSKUBatchInventoriesSummary(
        criteria,
        this.loadOnHandQtySummaryResponse,
        this.errorCallBack
      );
    }
  };
  loadOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.skuBatchSummaryResult != null) {
      let summaryDataList = new Array();
      if (
        !isEmptyArray(response.data.skuBatchSummaryResult.inventorySummaryBean)
      ) {
        summaryDataList =
          response.data.skuBatchSummaryResult.inventorySummaryBean;
      }
      this.setState({
        onHandQtySummaryDataList: summaryDataList,
        isShowOnHandQtySummaryPopup: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateOnHandQtySummaryPdf = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(1);
  };
  generateOnHandQtySummaryExcel = (e) => {
    if (e.detail === 1) this.generateOnHandQtySummaryReport(2);
  };
  generateOnHandQtySummaryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let inventoryDataBean = this.state.inventoryDataBean;
    let criteria = new SKUBatchInventorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = inventoryDataBean.fabricStyleCode;
    criteria.colorCode = inventoryDataBean.fabricStyleColorCode;
    criteria.excludeNonWarehouseInventory = true;
    criteria.fetchQuantityAvailableLinesOnly = true;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new SkuBatchInventorySummaryDetailsPrintRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    ReportService.getSkuBatchInventorySummaryDetailsPrintReport(
      listRequest,
      this.generateOnHandQtySummaryResponse,
      this.errorCallBack
    );
  };
  generateOnHandQtySummaryResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

 
  graphValueProvider = (rowData) => {
    if (
      parseFloat(rowData.onHandQuantity) >= parseFloat(rowData.receivedQuantity)
    ) {
      return "square-fill-blue";
    } else {
      return "square-partial-yellow";
    }
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Of.Rolls", "numberOfRolls", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.onHandQuantityClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No Of Bins", "numberOfBins", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLocations", "aisleInfoText", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    return columns;
  };
  onhandQtyColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("RollSKU#", "rollSkuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("BinLoc#", "aisleInfoText", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", "", true)
        .setGraphDetails(true, this.graphValueProvider)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
    );
    return columns;
  };
  onHandQtySummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "reserveCustomerCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "reserveCustomerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("No.Of.Rolls", "totalNumberOfRolls", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalYardage#", "totalYardage", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inventoryDataBean = this.state.inventoryDataBean;
    let onHandQtyDataList = this.state.onHandQtyDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          title={"OnHandQty On Rolls"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtyExcel(e)}
              >
                Excel
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.onHandQtySummaryOnClick(e)}
              >
                Summary
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>Company Code</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={inventoryDataBean.companyCode}
                    name={"companyCode"}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={onHandQtyDataList}
                  columns={this.onhandQtyColumns()}
                />
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtySummaryPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertSummaryModalCallBack}
          title={"Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl2}
              hideAlertCallBack={this.hideAlertCallBackLvl2}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryPdf(e)}
              >
                PDF
              </Button>
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.generateOnHandQtySummaryExcel(e)}
              >
                Excel
              </Button>
            </div>
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={inventoryDataBean.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={inventoryDataBean.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="mt-3">
                <CustomTable
                  data={this.state.onHandQtySummaryDataList}
                  columns={this.onHandQtySummaryColumns()}
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricCodeRef = props.fabricCodeRef;
  let colorCodeRef = React.createRef();
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            showCriteriaDialog={true}
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            lookupHandler={fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item Name</FormLabel>
          ) : (
            <FormLabel>FabricStyleName</FormLabel>
          )}
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel> color </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
            isMandatory={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function InventoryBinSummaryInquiry(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InventoryBinSummary {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default InventoryBinSummaryInquiry;
